import * as yup from 'yup'

import { i18WithDefault as t } from '@shared/locale'
import { Types } from 'service-api'

export const profileSchemaTemplate = {
  firstName: yup.string().max(200).required().label(t('contactForm.firstName')),
  lastName: yup.string().max(200).required().label(t('contactForm.lastName')),
  email: yup.string().email().required().label(t('contactForm.email')),
  phone: yup.string().length(10).required().label(t('contactForm.phone')),
  streetAddress: yup.string().max(200).required().label(t('contactForm.streetLine1')),
  streetAddress2: yup.string().max(200).label(t('contactForm.streetLine2')),
  city: yup.string().max(50).required(t('global.label.required')).label(t('contactForm.city')),
  state: yup.string().max(2).required(t('global.label.required')).label(t('contactForm.state')),
  zipCode: yup.string().max(5).required(t('global.label.required')).label(t('contactForm.zipCode')),
  country: yup.string().length(2).required().label(t('contactForm.country')),
}

export const profileSchema = yup.object(profileSchemaTemplate)

export type TProfileSchema = yup.InferType<typeof profileSchema>

export const setupInitialValues = (lup?: Types.LocationUserProfileClientDto) => {
  return {
    firstName: lup?.firstName || '',
    lastName: lup?.lastName || '',
    email: lup?.email || '',
    phone: lup?.phone || '',
    streetAddress: lup?.streetAddress || '',
    streetAddress2: lup?.streetAddress2 || '',
    city: lup?.city || '',
    state: lup?.state || '',
    zipCode: lup?.zipCode || '',
    country: 'US',
  }
}
